module.exports = __webpack_public_path__ + "static/media/gc.5493339e.gif";